import { assign, setup } from "xstate";

export enum LifestyleFlowState {
  Idle = "idle",
  FlyupModal = "flyupModal",
  AwaitingPermissions = "awaitingPermissions",
  Success = "success",
  Dashboard = "dashboard",
}

export const eventNames = {
  OPEN_FLYUP: "OPEN_FLYUP",
  CLOSE_FLYUP: "CLOSE_FLYUP",
  CONNECT_CLICKED: "CONNECT_CLICKED",
  PERMISSIONS_GRANTED: "PERMISSIONS_GRANTED",
  PERMISSIONS_DENIED: "PERMISSIONS_DENIED",
  CONTINUE_TO_DASHBOARD: "CONTINUE_TO_DASHBOARD",
  CLOSE_SUCCESS: "CLOSE_SUCCESS",
  BACK_TO_IDLE: "BACK_TO_IDLE",
  OPEN_SUCCESS: "OPEN_SUCCESS",
};

interface Context {
  hasPermissions: boolean;
}

const initialContext: Context = {
  hasPermissions: false,
};

export const lifestyleFlowMachine = setup({
  types: {
    context: {} as Context,
  },
  actions: {
    setPermissionsGranted: assign(() => ({
      hasPermissions: true,
    })),
  },
}).createMachine({
  id: "lifestyleFlow",
  initial: LifestyleFlowState.Idle,
  context: initialContext,
  states: {
    [LifestyleFlowState.Idle]: {
      on: {
        [eventNames.OPEN_FLYUP]: {
          target: LifestyleFlowState.FlyupModal,
        },
        [eventNames.OPEN_SUCCESS]: {
          target: LifestyleFlowState.Success,
        },
      },
    },
    [LifestyleFlowState.FlyupModal]: {
      on: {
        [eventNames.CLOSE_FLYUP]: {
          target: LifestyleFlowState.Idle,
        },
        [eventNames.CONNECT_CLICKED]: {
          target: LifestyleFlowState.AwaitingPermissions,
        },
      },
    },
    [LifestyleFlowState.AwaitingPermissions]: {
      on: {
        [eventNames.PERMISSIONS_GRANTED]: {
          target: LifestyleFlowState.Success,
          actions: ["setPermissionsGranted"],
        },
        [eventNames.PERMISSIONS_DENIED]: {
          target: LifestyleFlowState.Idle,
        },
      },
    },
    [LifestyleFlowState.Success]: {
      on: {
        [eventNames.CONTINUE_TO_DASHBOARD]: {
          target: LifestyleFlowState.Dashboard,
        },
        [eventNames.CLOSE_SUCCESS]: {
          target: LifestyleFlowState.Idle,
        },
      },
    },
    [LifestyleFlowState.Dashboard]: {
      on: {
        [eventNames.BACK_TO_IDLE]: {
          target: LifestyleFlowState.Idle,
        },
      },
    },
  },
});
